import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {requestPassword} from '../redux/AuthCRUD'
import {Alert} from 'react-bootstrap'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('EL correo es requerido'),
})

export function ForgotPassword() {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [error, setError] = useState<boolean>(false)
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setTimeout(() => {
        requestPassword(values.email)
          .then((res) => {
            if (res.data) {
              toogleSuccess()
            } else {
              toogleError()
              setSubmitting(false)
              setStatus('The login detail is incorrect')
            }
          })
          .catch(() => {
            toogleError()
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 1000)
    },
  })

  const toogleSuccess = () => {
    setSuccess(true)
    setTimeout(function () {
      setSuccess(false)
    }, 4000)
    setLoading(false)
  }

  const toogleError = () => {
    setError(true)
    setTimeout(function () {
      setError(false)
    }, 3000)
    setLoading(false)
  }

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          <h1 className='text-dark mb-3'>Olvido su contraseña?</h1>
          <div className='text-gray-400 fw-bold fs-4'>
            Ingrese su correo electrónico para restablecer su contraseña.
          </div>
        </div>

        {success && (
          <Alert variant='success'>
            Enviado restablecimiento de contraseña. Por favor revise su correo electrónico
          </Alert>
        )}
        {error && (
          <Alert variant='danger'>
            Lo sentimos, parece que se han detectado algunos errores, inténtalo de nuevo.
          </Alert>
        )}

        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>Correo</label>
          <input
            type='email'
            placeholder=''
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>

        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
          >
            {!loading && 'Enviar'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Cargando...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
              disabled={formik.isSubmitting || !formik.isValid}
            >
              Cancelar
            </button>
          </Link>
        </div>
      </form>
    </>
  )
}
